import {isInsideAutomation} from "./utils/automation-helpers";

export function loadJQueryForAutomation(): Promise<void> {
    if(!isInsideAutomation()) {
        return Promise.resolve();
    }
    return new Promise<void>((resolve, reject) => {
        const scriptTag = document.createElement('script');
        scriptTag.src = "https://code.jquery.com/jquery-3.7.1.min.js";
        scriptTag.onload = () => {
            resolve();
        };
        scriptTag.onerror = (err: any) => {
            reject(err);
        };
        document.head.appendChild(scriptTag);
    })
}